var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMastercard = function SvgMastercard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 33,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 46.625,
    height: 31.625,
    x: 0.688,
    y: 0.688,
    fill: "#fff",
    stroke: "#D6DCE9",
    strokeWidth: 1.375,
    rx: 4.813
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ED0006",
    fillRule: "evenodd",
    d: "M24.343 23.59a9.244 9.244 0 0 1-6.07 2.268c-5.169 0-9.359-4.25-9.359-9.491 0-5.243 4.19-9.492 9.359-9.492 2.316 0 4.436.854 6.07 2.267a9.244 9.244 0 0 1 6.07-2.267c5.169 0 9.359 4.25 9.359 9.492 0 5.242-4.19 9.491-9.359 9.491a9.244 9.244 0 0 1-6.07-2.267Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9A000",
    fillRule: "evenodd",
    d: "M24.343 23.59a9.526 9.526 0 0 0 3.288-7.223 9.526 9.526 0 0 0-3.288-7.225 9.244 9.244 0 0 1 6.07-2.267c5.169 0 9.359 4.25 9.359 9.492 0 5.242-4.19 9.491-9.359 9.491a9.244 9.244 0 0 1-6.07-2.267Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF5E00",
    fillRule: "evenodd",
    d: "M24.343 23.591a9.527 9.527 0 0 0 3.288-7.224 9.526 9.526 0 0 0-3.288-7.224 9.526 9.526 0 0 0-3.288 7.224 9.526 9.526 0 0 0 3.288 7.224Z",
    clipRule: "evenodd"
  })));
};
export default SvgMastercard;